import React, { useState } from 'react';
import { RARITY_OPTIONS, SOURCE_OPTIONS } from '../../utils/constants';

export default function AlertForm({ onCreateAlert }) {
  const [form, setForm] = useState({
    card_name_pattern: '',
    min_price: '',
    max_price: '',
    rarity: '',
    extension: '',
    source: '',
    email_notify: false,
  });

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {};
    Object.entries(form).forEach(([key, value]) => {
      if (key === 'email_notify') {
        data[key] = value;
      } else if (value !== '' && value !== null) {
        data[key] = key.includes('price') ? parseFloat(value) : value;
      }
    });
    // Need at least one filter criteria (besides email_notify)
    const filterKeys = Object.keys(data).filter(k => k !== 'email_notify');
    if (filterKeys.length === 0) return;
    onCreateAlert(data);
    setForm({
      card_name_pattern: '', min_price: '', max_price: '',
      rarity: '', extension: '', source: '', email_notify: false,
    });
  };

  return (
    <form className="alert-form" onSubmit={handleSubmit}>
      <h3>Create Alert</h3>
      <div className="filter-row">
        <div className="filter-field">
          <label>Card Name (contains)</label>
          <input
            type="text"
            value={form.card_name_pattern}
            onChange={(e) => handleChange('card_name_pattern', e.target.value)}
            placeholder="e.g. Charizard"
          />
        </div>
        <div className="filter-field">
          <label>Extension / Set</label>
          <input
            type="text"
            value={form.extension}
            onChange={(e) => handleChange('extension', e.target.value)}
            placeholder="e.g. Evolving Skies"
          />
        </div>
        <div className="filter-field">
          <label>Rarity</label>
          <select
            value={form.rarity}
            onChange={(e) => handleChange('rarity', e.target.value)}
          >
            <option value="">Any</option>
            {RARITY_OPTIONS.map((r) => (
              <option key={r} value={r}>{r}</option>
            ))}
          </select>
        </div>
        <div className="filter-field">
          <label>Source</label>
          <select
            value={form.source}
            onChange={(e) => handleChange('source', e.target.value)}
          >
            <option value="">Any</option>
            {SOURCE_OPTIONS.map((s) => (
              <option key={s.value} value={s.value}>{s.label}</option>
            ))}
          </select>
        </div>
        <div className="filter-field">
          <label>Min Price</label>
          <input
            type="number"
            value={form.min_price}
            onChange={(e) => handleChange('min_price', e.target.value)}
            placeholder="0"
            min="0"
            step="0.01"
          />
        </div>
        <div className="filter-field">
          <label>Max Price</label>
          <input
            type="number"
            value={form.max_price}
            onChange={(e) => handleChange('max_price', e.target.value)}
            placeholder="999"
            min="0"
            step="0.01"
          />
        </div>
      </div>
      <div className="filter-row" style={{ alignItems: 'center' }}>
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={form.email_notify}
            onChange={(e) => handleChange('email_notify', e.target.checked)}
          />
          Send email notification when triggered
        </label>
        <button type="submit" className="btn btn-primary">Create Alert</button>
      </div>
    </form>
  );
}
